import { PostAPI } from 'Components/Helper/Helpers';

export const Select = async (request) => {
    return PostAPI(request, 'DMTPipeMaster/Select');
};

export const ActiveDeactive = async (request) => {
    return PostAPI(request, 'DMTPipeMaster/ActiveDeactive');
};

export const SelectDmtPipe = async (request) => {
    return PostAPI(request, 'DMTPipeMaster/SelectDmtPipe');
};
